import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responses']['PUT'];
type Input = ThisApi['params'];
type Body = ThisApi['body'];

const updateQuestionnaireResponses = async ({ questionnaireId }: Input, body: Body): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responses', { questionnaireId });
  const data = await formsBackendClient.put(path, body);
  return data.data;
};

export default updateQuestionnaireResponses;
